import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
// import moment from 'moment';

interface RegulatorManagerState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    lastMeta: {
        page: number;
        pageSize: number;
        totalCount: number;
        totalPages: number;
    };

    documents: any[];
}

const state: RegulatorManagerState = {
    loading: false,
    loaded: false,
    fatalError: false,

    lastMeta: {
        page: 0,
        pageSize: 0,
        totalCount: 0,
        totalPages: 0
    },

    documents: [],
};

export const ITEMS_LIST = 'GET_CITY_LIST';

export const actions: ActionTree<RegulatorManagerState, RootState> = {
    loadData({ commit, getters, dispatch }, query) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            const columns: any = {
                "id": "voc_regulators.id",
                "name": "voc_regulators.name",
                "created_at": "voc_regulators.created_at",
            };

            const filter: any[] = [];

            if (query.name) {
                filter.push({ "$ilike": ["voc_regulators.name", {"$": `%${query.name}%`}] })
            }

            vm.$db([
                vm.$q(ITEMS_LIST)
                .raw('documents.list')
                .action({
                    "columns": columns,
                    "from": "s:voc_regulators",
                    "from_as": "voc_regulators",
                    page_size: 10,
                    ...({page: parseInt(query.page) || 1}),
                    ...({
                        order: [
                            query.sortDirection == 'desc' ? { $desc: [columns[query.sortField || 'name' ]] } : { $asc: [columns[query.sortField || 'name']] }
                        ]
                    }),
                    ...(
                        filter.length > 1 ?
                        {
                            "where": {
                                "$and": filter
                            }
                        } : {
                            "where": filter[0]
                        }
                    )

                })
            ]).then(((result: ServerResult) => {
                commit('SET_ITEMS_LIST', result.getOperation(ITEMS_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    saveTodoType({ commit, getters, dispatch }, data) {
        const vm = (this as any)._vm;

        const query = data.id ?
            vm.$q('SAVE_DOCUMENT').update(data.id, data) :
            vm.$q('SAVE_DOCUMENT').create('voc_regulators', data);

        return new Promise((resolve, reject) => {
            vm.$db([
                query
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('SAVE_DOCUMENT');

                if (operationResult.hasError()) {
                    reject();
                } else {
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.error('errror', error)
                reject(error);
            });
        });
    },

};

export const mutations: MutationTree<RegulatorManagerState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_ITEMS_LIST(state, data) {
        state.documents = data.documents;

        state.lastMeta = {
            page: data.meta.page,
            pageSize: data.meta.page_size,
            totalCount: data.meta.total_count,
            totalPages: data.meta.total_pages
        };
    },
};

const getters = {

};

export const STORE_KEY = '$_regulator_manger';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
